<template>
  <div class="profile-banner-wrap">
    <div class="icon-bar">
      <a
        v-if="social.instagram"
        :href="social.instagram"
        target="_blank"
        class="instagram"
        ><i class="fa fa-instagram"></i
      ></a>
      <a
        v-if="social.facebook"
        :href="social.facebook"
        target="_blank"
        class="facebook"
        ><i class="fa fa-facebook"></i
      ></a>
      <a
        v-if="social.twitter"
        :href="social.twitter"
        target="_blank"
        class="twitter"
        ><i class="fa fa-twitter"></i
      ></a>
      <a
        v-if="social.flickr"
        :href="social.flickr"
        target="_blank"
        class="google"
        ><i class="fa fa-flickr" aria-hidden="true"></i
      ></a>
      <a
        v-if="social.linkedin"
        :href="social.linkedin"
        target="_blank"
        class="linkedin"
        ><i class="fa fa-linkedin"></i
      ></a>
      <a
        v-if="social.youtube"
        :href="social.youtube"
        target="_blank"
        class="youtube"
        ><i class="fa fa-youtube"></i
      ></a>
      <a
        v-if="social.podcast"
        :href="social.podcast"
        target="_blank"
        class="podcast"
        ><i class="fa fa-podcast"></i
      ></a>
    </div>
    <div class="slider-content-wrap">
      <a-row :gutter="0">
        <a-col :md="8">
          <div class="user_image check">
            <img :src="logoImage" alt="logo" class="game-logo" />
          </div>
        </a-col>
        <a-col :md="16">
          <carousel
            :per-page="1"
            :mouse-drag="true"
            :adjustableHeight="true"
            :autoplay="true"
            :loop="true"
            :paginationEnabled="true"
            class="custom-carousel"
          >
            <Slide v-for="item in sliderImages" :key="item._id">
              <div class="img-wrap">
                <img :src="item" alt="No Images Found" />
              </div>
            </Slide>
          </carousel>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  mounted() {},
  props: {
    sliderImages: {
      type: Array,
      default: () => [],
    },
    image: {
      type: String,
      default: "",
    },
    social: {
      type: Object,
      default: () => ({}),
    },
    logoImage: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-banner-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 100px;
  .icon-bar {
    width: 50px;
    a {
      display: block;
      text-align: center;
      padding: 8px;
      transition: all 0.3s ease;
      color: white;
      font-size: 20px;
      &.instagram {
        background: radial-gradient(
          circle at 30% 107%,
          #fdf497 0%,
          #fdf497 5%,
          #fd5949 45%,
          #d6249f 60%,
          #285aeb 90%
        );
        color: #fff;
      }
      &.flicker {
        background: gray;
        color: black;
      }
      &.podcast {
        background: #f25607;
        color: white;
      }
      &.facebook {
        background: #3b5998;
        color: white;
      }
      &.twitter {
        background: #55acee;
        color: white;
      }
      &.google {
        background: #dd4b39;
        color: white;
      }
      &.linkedin {
        background: #007bb5;
        color: white;
      }
      &.youtube {
        background: #bb0000;
        color: white;
      }
      &:hover {
        color: #3b5998;
        &.instagram {
          color: #d6249f;
          background: #fff;
        }
        &.twitter {
          color: #55acee;
        }
        &.google {
          color: #dd4b39;
        }
        &.linkedin {
          color: #007bb5;
        }
        &.youtube {
          color: #bb0000;
        }
      }
      &:focus,
      &:active {
        &.facebook {
          background: #3b5998 !important;
          color: white;
        }
        &.twitter {
          background: #55acee !important;
          color: white;
        }
        &.google {
          background: #dd4b39 !important;
          color: white;
        }
        &.linkedin {
          background: #007bb5 !important;
          color: white;
        }
        &.youtube {
          background: #bb0000 !important;
          color: white;
        }
      }
    }
  }
  .slider-content-wrap {
    width: calc(100% - 50px);
    .user_image {
      padding: 10px;
      height: 400px;
      width: 100%;
      background: #ddd;
      overflow: hidden;
    }
    .game-logo {
      object-position: top;
      object-fit: cover;
      height: 100%;
    }
    .custom-carousel {
      .img-wrap {
        height: 400px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: top;
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .profile-banner-wrap {
    .slider-content-wrap {
      .user_image {
        height: 350px;
      }
      .custom-carousel {
        .img-wrap {
          height: 350px;
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .profile-banner-wrap {
    .icon-bar {
      width: 35px;
      a {
        padding: 5px;
        font-size: 16px;
      }
    }
    .slider-content-wrap {
      width: calc(100% - 35px);
      .user_image {
        padding: 10px;
        height: 250px;
      }
      .custom-carousel {
        .img-wrap {
          height: 250px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .profile-banner-wrap {
    flex-direction: column;
    // align-items: flex-start;
    .icon-bar {
      display: flex;
      justify-content: center;
      a {
        padding: 11px 14px;
      }
    }
    .slider-content-wrap {
      margin: 0 auto;
      width: 100%;
      .user_image {
        margin: 0 auto;
        max-width: 314px;
        height: 330px;
        padding: 15px;
        // display: none;
      }
      .custom-carousel {
        .img-wrap {
          height: 250px;
        }
      }
    }
  }
}
@media only screen and (max-width: 575px) {
  .profile-banner-wrap {
    .icon-bar {
      a {
        padding: 11px 14px;
        font-size: 16px;
      }
    }
    .slider-content-wrap {
      .custom-carousel {
        .img-wrap {
          height: 250px;
        }
      }
    }
  }
}
</style>
